var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { DocumentLibraryContextProvider } from '../../../providers';
import { SelectFilesDialog } from '../components/SelectFilesDialog';
export const showSelectFilesDialog = (params) => showCustomDialog({
    fullScreen: true,
    content: (handleClose) => (React.createElement(DocumentLibraryContextProvider, null,
        React.createElement(SelectFilesDialog, Object.assign({}, params, { onClose: () => handleClose(), onFilesSelect: (selectedFiles) => __awaiter(void 0, void 0, void 0, function* () {
                return params.onFilesSelect({
                    selectedFiles,
                    onClose: handleClose,
                });
            }) })))),
});
